import { useChatStore } from '../../store/chat';
import { Avatar } from './Avatar';

export function Sidebar() {
  const lastAssistantText = useChatStore(
    (s) => s.messages.findLast?.((m) => m.role === 'assistant')?.text ?? ''
  );

  return (
    <div className="w-[30vw] min-w-[360px] flex-shrink-0 bg-white border-r border-[#E9EEF2] hidden md:flex flex-col">
      {/* Barra superior: você + ações */}
      <div className="h-[60px] bg-[#F0F2F5] flex items-center px-4 gap-3 flex-shrink-0">
        <div className="w-10 h-10 rounded-full bg-[#DFE5E7] flex items-center justify-center flex-shrink-0">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="#8696A0" aria-hidden="true">
            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
          </svg>
        </div>
        <div className="flex-1 text-[15px] font-medium text-[#111B21]">Você</div>
        <button
          type="button"
          aria-label="Mais opções"
          className="w-9 h-9 flex items-center justify-center rounded-full text-[#54656F] hover:bg-black/5 active:scale-90 transition-[transform,background-color] duration-150"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <circle cx="12" cy="5" r="1.5" />
            <circle cx="12" cy="12" r="1.5" />
            <circle cx="12" cy="19" r="1.5" />
          </svg>
        </button>
      </div>

      {/* Busca (estética WhatsApp) */}
      <div className="px-3 py-2 flex-shrink-0">
        <div className="flex items-center gap-3 bg-[#F0F2F5] rounded-lg px-3 h-9">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#8696A0" strokeWidth="2" aria-hidden="true">
            <circle cx="11" cy="11" r="8" />
            <path d="M21 21l-4.35-4.35" />
          </svg>
          <span className="text-[14px] text-[#8696A0] select-none">Pesquisar</span>
        </div>
      </div>

      {/* Conversa ativa: Minas Brasil */}
      <div className="overflow-y-auto flex-1">
        <div className="px-3 py-3 flex items-center gap-3 cursor-default bg-[#F5F6F6] border-l-[3px] border-[#075E54]">
          <Avatar size={49} />
          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between gap-2">
              <div className="text-[16px] font-medium text-[#111B21] truncate">Minas Brasil</div>
              <span className="text-[12px] text-[#667781] flex-shrink-0">agora</span>
            </div>
            <div className="text-[13px] text-[#667781] truncate">
              {lastAssistantText || 'Assistente de orçamentos magistrais'}
            </div>
          </div>
        </div>
      </div>

      {/* Rodapé de marca */}
      <div className="px-4 py-3 border-t border-[#E9EEF2] flex items-center gap-2 text-[#8696A0] flex-shrink-0">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z" />
        </svg>
        <span className="text-[11px] tracking-wide">Farmácia de Manipulação — Montes Claros, MG</span>
      </div>
    </div>
  );
}
